import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol1033 = React.lazy(() => import('./symbols/1033_atom_nuclear_learning_physics'));
const Symbol1034 = React.lazy(() => import('./symbols/1034_lab_chemistry_experiment'));
const Symbol1035 = React.lazy(() => import('./symbols/1035_bomb'));
const Symbol1036 = React.lazy(() => import('./symbols/1036_brain_thinking_mind_knowledge'));
const Symbol1037 = React.lazy(() => import('./symbols/1037_brain_thinking_mind_knowledge'));
const Symbol1038 = React.lazy(
  () => import('./symbols/1038_study_university_school_degree_graduate')
);
const Symbol1039 = React.lazy(() => import('./symbols/1039_brain_thinking_mind_knowledge'));
const Symbol1040 = React.lazy(() => import('./symbols/1040_mathematics_root_equation'));
const Symbol1041 = React.lazy(() => import('./symbols/1041_mathematics_curve_coordinate_system'));
const Symbol1042 = React.lazy(
  () => import('./symbols/1042_3d_dimensions_object_coordinate_system')
);
const Symbol1043 = React.lazy(
  () => import('./symbols/1043_mathematics_calculate_add_subtract_divide_multiply')
);
const Symbol1044 = React.lazy(() => import('./symbols/1044_space_shuttle_aircraft_nasa_rocket'));
const Symbol1045 = React.lazy(() => import('./symbols/1045_space_moon_planet_galaxy_saturn'));
const Symbol1046 = React.lazy(
  () => import('./symbols/1046_telescope_astronomy_stars_space_galaxy')
);
const Symbol1047 = React.lazy(() => import('./symbols/1047_alien'));
const Symbol1048 = React.lazy(() => import('./symbols/1048_spaceship_alien'));

export interface IProps {}

const Science: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="1033_atom_nuclear_learning_physics" symbol={<Symbol1033 />} />
      <LazySymbol id="1034_lab_chemistry_experiment" symbol={<Symbol1034 />} />
      <LazySymbol id="1035_bomb" symbol={<Symbol1035 />} />
      <LazySymbol id="1036_brain_thinking_mind_knowledge" symbol={<Symbol1036 />} />
      <LazySymbol id="1037_brain_thinking_mind_knowledge" symbol={<Symbol1037 />} />
      <LazySymbol id="1038_study_university_school_degree_graduate" symbol={<Symbol1038 />} />
      <LazySymbol id="1039_brain_thinking_mind_knowledge" symbol={<Symbol1039 />} />
      <LazySymbol id="1040_mathematics_root_equation" symbol={<Symbol1040 />} />
      <LazySymbol id="1041_mathematics_curve_coordinate_system" symbol={<Symbol1041 />} />
      <LazySymbol id="1042_3d_dimensions_object_coordinate_system" symbol={<Symbol1042 />} />
      <LazySymbol
        id="1043_mathematics_calculate_add_subtract_divide_multiply"
        symbol={<Symbol1043 />}
      />
      <LazySymbol id="1044_space_shuttle_aircraft_nasa_rocket" symbol={<Symbol1044 />} />
      <LazySymbol id="1045_space_moon_planet_galaxy_saturn" symbol={<Symbol1045 />} />
      <LazySymbol id="1046_telescope_astronomy_stars_space_galaxy" symbol={<Symbol1046 />} />
      <LazySymbol id="1047_alien" symbol={<Symbol1047 />} />
      <LazySymbol id="1048_spaceship_alien" symbol={<Symbol1048 />} />
    </>
  );
});

Science.displayName = 'Science';

export default Science;
